<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1173840" style="color: #82a339"><b>TOMATO AND RICOTTA SALATA <br/> BRUSCHETTA</b></p>
<p class="ext" id="d7e1174640"><b><i>Bruschetta is toasted Italian bread that is rubbed with garlic and drizzled with olive oil. It’s often topped with savory ingredients to make a simple appetizer. Here we use ripe tomatoes and ricotta salata, a lightly salted and pressed sheep’s milk cheese. Ricotta salata can be found at Italian markets and specialty food stores.</i></b></p>
<p class="h4" id="d7e1177140" style="color: #496210"><b>Prep: 25 minutes</b></p>
<p class="ul" id="d7e1177640">1 loaf (8 ounces) Italian bread, cut on diagonal <br/> into ½-inch-thick slices</p>
<p class="ul" id="d7e1179040">8 garlic cloves, each cut in half</p>
<p class="ul" id="d7e1179340">1 pound ripe plum tomatoes (6 medium), seeded <br/> and cut into ½-inch pieces</p>
<p class="ul" id="d7e1180840">1 tablespoon finely chopped red onion</p>
<p class="ul" id="d7e1181140">1 tablespoon chopped fresh basil</p>
<p class="ul" id="d7e1181540">4 ounces ricotta salata, feta, or goat cheese, <br/> cut into ½-inch pieces</p>
<p class="ul" id="d7e1182940">2 tablespoons extra-virgin olive oil</p>
<p class="ul" id="d7e1183240">2 teaspoons balsamic vinegar</p>
<p class="ul" id="d7e1183640">¼ teaspoon salt</p>
<p class="ul" id="d7e1184540">¼ teaspoon coarsely ground black pepper</p>
<p class="pub" id="d7e1185640" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 400°F. Place bread slices on cookie sheet and bake until lightly toasted, about 5 minutes. Rub one side of each toast slice with cut side of garlic.</p>
<p class="pub" id="d7e1187340"><span style="color: #c15b49"><b>2.</b></span> Meanwhile, in bowl, gently toss tomatoes, onion, basil, cheese, oil, vinegar, salt, and pepper until combined.</p>
<p class="pub" id="d7e1188640"><span style="color: #c15b49"><b>3.</b></span> To serve, spoon tomato mixture on garlic-rubbed side of toast slices. Makes 16 bruschetta.</p>
<p class="ntx" id="d7e1190040">Each bruschetta: About 79 calories, 2g protein, 9g carbohydrate, 4g total fat (1g saturated), 6mg cholesterol, 236mg sodium.</p>
<p class="h4l" id="d7e1191040" style="color: #496210"><b>TUSCAN WHITE-BEAN BRUSCHETTA</b></p>
<p class="tx4" id="d7e1191540">Prepare toast as directed but prepare topping as follows: In bowl, with fork, lightly mash <b>1 can (15½ to 19 ounces) white kidney beans (cannellini), </b>rinsed and drained, with <b>1 tablespoon fresh lemon juice.</b> Stir in <b>1 tablespoon olive oil, 2 teaspoons chopped fresh parsley, 1 teaspoon minced fresh sage, ¼ teaspoon salt, </b>and <b>⅛ teaspoon coarsely ground black pepper. </b>Just before serving, spoon mixture over garlic-rubbed side of toast slices. Sprinkle with <b>1 teaspoon chopped fresh parsley. </b>Makes 16 bruschetta.</p>
<p class="ntx" id="d7e1199240">Each bruschetta: About 33 calories, 2g protein, 4g carbohydrate, 1g total fat (0g saturated), 0mg cholesterol, 77mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c28_r1.vue?71d67a15